import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../utils/api';

const EmailPreferencesUnsubscribe = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const [contactInfo, setContactInfo] = useState<any>(null);

  useEffect(() => {
    if (!token) {
      setError('This unsubscribe link is missing its token.');
      setLoading(false);
      return;
    }
    const run = async () => {
      try {
        const response = await api.get(`/api/email-preferences/unsubscribe?token=${encodeURIComponent(token)}`);
        setSuccess(true);
        setContactInfo(response.data.contact);
      } catch (err: any) {
        setError(err.response?.data?.message || 'Failed to unsubscribe. Please try again.');
      } finally {
        setLoading(false);
      }
    };
    run();
  }, [token]);

  if (loading) {
    return (
      <div className="container mt-5">
        <div className="row justify-content-center">
          <div className="col-md-6 text-center">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-3">Processing your request...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container mt-5 mb-5">
      <div className="row justify-content-center">
        <div className="col-md-8">
          <div className="card shadow">
            <div className="card-body p-5">
              {error ? (
                <>
                  <div className="text-center mb-4">
                    <i className="bi bi-x-circle text-danger" style={{ fontSize: '4rem' }}></i>
                    <h2 className="mt-3">Unsubscribe Failed</h2>
                  </div>
                  <div className="alert alert-danger">{error}</div>
                  <div className="text-center mt-4">
                    <button className="btn btn-secondary" onClick={() => navigate('/')}>
                      Return to Home
                    </button>
                  </div>
                </>
              ) : success ? (
                <>
                  <div className="text-center mb-4">
                    <i className="bi bi-check-circle text-success" style={{ fontSize: '4rem' }}></i>
                    <h2 className="mt-3">Preferences Updated</h2>
                  </div>

                  {contactInfo && (
                    <div className="alert alert-success">
                      <p className="mb-0">
                        <strong>{contactInfo.name}</strong> ({contactInfo.email}) will no longer receive
                        reminder and notification emails from CEC Track.
                      </p>
                      {contactInfo.unsubscribedDate && (
                        <p className="mb-0 mt-2">
                          <small>Previously unsubscribed on: {new Date(contactInfo.unsubscribedDate).toLocaleDateString()}</small>
                        </p>
                      )}
                    </div>
                  )}

                  <div className="bg-light p-4 rounded mt-4">
                    <h5>What happens next?</h5>
                    <ul className="mb-0">
                      <li>You will no longer receive deadline reminders, onboarding tips, or other notification emails</li>
                      <li>Changes take effect immediately</li>
                      <li>You will still receive essential account and security emails (password resets, verification codes, team/billing notices)</li>
                      <li>You can turn reminders back on any time from your account settings, or by contacting support</li>
                    </ul>
                  </div>

                  <div className="text-center mt-4">
                    <button className="btn btn-secondary" onClick={() => navigate('/')}>
                      Return to Home
                    </button>
                  </div>
                </>
              ) : null}

              <div className="text-center mt-5 pt-4 border-top">
                <p className="text-muted small mb-1">
                  Changed your mind? Contact us at <a href="mailto:support@cectrack.com">support@cectrack.com</a>
                </p>
                <p className="text-muted small mb-0">
                  CEC Track — Continuing Education Compliance Made Simple
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailPreferencesUnsubscribe;
